var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-label",
      class: {
        origin: _vm.side === "origin",
        destination: _vm.side === "destination"
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        },
        contextmenu: function($event) {
          return _vm.$emit("open-menu-object", $event)
        }
      }
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c("p", _vm._g(_vm._b({}, "p", attrs, false), on), [
                    _vm._v(_vm._s(_vm.objectName))
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { style: { fontSize: "10px" } }, [
            _vm._v(_vm._s(_vm.objectName))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce74bd10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce74bd10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataObject.vue
// module id = null
// module chunks = 